// source: PublicLimitDepthsV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.PublicLimitDepthV3ApiItem', null, global);
goog.exportSymbol('proto.PublicLimitDepthsV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicLimitDepthsV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.PublicLimitDepthsV3Api.repeatedFields_, null);
};
goog.inherits(proto.PublicLimitDepthsV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicLimitDepthsV3Api.displayName = 'proto.PublicLimitDepthsV3Api';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicLimitDepthV3ApiItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PublicLimitDepthV3ApiItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicLimitDepthV3ApiItem.displayName = 'proto.PublicLimitDepthV3ApiItem';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.PublicLimitDepthsV3Api.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicLimitDepthsV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicLimitDepthsV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicLimitDepthsV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicLimitDepthsV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
asksList: jspb.Message.toObjectList(msg.getAsksList(),
    proto.PublicLimitDepthV3ApiItem.toObject, includeInstance),
bidsList: jspb.Message.toObjectList(msg.getBidsList(),
    proto.PublicLimitDepthV3ApiItem.toObject, includeInstance),
eventtype: jspb.Message.getFieldWithDefault(msg, 3, ""),
version: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicLimitDepthsV3Api}
 */
proto.PublicLimitDepthsV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicLimitDepthsV3Api;
  return proto.PublicLimitDepthsV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicLimitDepthsV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicLimitDepthsV3Api}
 */
proto.PublicLimitDepthsV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.PublicLimitDepthV3ApiItem;
      reader.readMessage(value,proto.PublicLimitDepthV3ApiItem.deserializeBinaryFromReader);
      msg.addAsks(value);
      break;
    case 2:
      var value = new proto.PublicLimitDepthV3ApiItem;
      reader.readMessage(value,proto.PublicLimitDepthV3ApiItem.deserializeBinaryFromReader);
      msg.addBids(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEventtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicLimitDepthsV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicLimitDepthsV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicLimitDepthsV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicLimitDepthsV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAsksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.PublicLimitDepthV3ApiItem.serializeBinaryToWriter
    );
  }
  f = message.getBidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.PublicLimitDepthV3ApiItem.serializeBinaryToWriter
    );
  }
  f = message.getEventtype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated PublicLimitDepthV3ApiItem asks = 1;
 * @return {!Array<!proto.PublicLimitDepthV3ApiItem>}
 */
proto.PublicLimitDepthsV3Api.prototype.getAsksList = function() {
  return /** @type{!Array<!proto.PublicLimitDepthV3ApiItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PublicLimitDepthV3ApiItem, 1));
};


/**
 * @param {!Array<!proto.PublicLimitDepthV3ApiItem>} value
 * @return {!proto.PublicLimitDepthsV3Api} returns this
*/
proto.PublicLimitDepthsV3Api.prototype.setAsksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.PublicLimitDepthV3ApiItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PublicLimitDepthV3ApiItem}
 */
proto.PublicLimitDepthsV3Api.prototype.addAsks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PublicLimitDepthV3ApiItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PublicLimitDepthsV3Api} returns this
 */
proto.PublicLimitDepthsV3Api.prototype.clearAsksList = function() {
  return this.setAsksList([]);
};


/**
 * repeated PublicLimitDepthV3ApiItem bids = 2;
 * @return {!Array<!proto.PublicLimitDepthV3ApiItem>}
 */
proto.PublicLimitDepthsV3Api.prototype.getBidsList = function() {
  return /** @type{!Array<!proto.PublicLimitDepthV3ApiItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PublicLimitDepthV3ApiItem, 2));
};


/**
 * @param {!Array<!proto.PublicLimitDepthV3ApiItem>} value
 * @return {!proto.PublicLimitDepthsV3Api} returns this
*/
proto.PublicLimitDepthsV3Api.prototype.setBidsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.PublicLimitDepthV3ApiItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PublicLimitDepthV3ApiItem}
 */
proto.PublicLimitDepthsV3Api.prototype.addBids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.PublicLimitDepthV3ApiItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PublicLimitDepthsV3Api} returns this
 */
proto.PublicLimitDepthsV3Api.prototype.clearBidsList = function() {
  return this.setBidsList([]);
};


/**
 * optional string eventType = 3;
 * @return {string}
 */
proto.PublicLimitDepthsV3Api.prototype.getEventtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicLimitDepthsV3Api} returns this
 */
proto.PublicLimitDepthsV3Api.prototype.setEventtype = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string version = 4;
 * @return {string}
 */
proto.PublicLimitDepthsV3Api.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicLimitDepthsV3Api} returns this
 */
proto.PublicLimitDepthsV3Api.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicLimitDepthV3ApiItem.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicLimitDepthV3ApiItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicLimitDepthV3ApiItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicLimitDepthV3ApiItem.toObject = function(includeInstance, msg) {
  var f, obj = {
price: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicLimitDepthV3ApiItem}
 */
proto.PublicLimitDepthV3ApiItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicLimitDepthV3ApiItem;
  return proto.PublicLimitDepthV3ApiItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicLimitDepthV3ApiItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicLimitDepthV3ApiItem}
 */
proto.PublicLimitDepthV3ApiItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPrice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicLimitDepthV3ApiItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicLimitDepthV3ApiItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicLimitDepthV3ApiItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicLimitDepthV3ApiItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string price = 1;
 * @return {string}
 */
proto.PublicLimitDepthV3ApiItem.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicLimitDepthV3ApiItem} returns this
 */
proto.PublicLimitDepthV3ApiItem.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string quantity = 2;
 * @return {string}
 */
proto.PublicLimitDepthV3ApiItem.prototype.getQuantity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicLimitDepthV3ApiItem} returns this
 */
proto.PublicLimitDepthV3ApiItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto);
